// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"bf16873b","453":"c3de1ac9","455":"b5783398","977":"e3d5dcc1"}[chunkId] + ".chunk.js";
};